export const protocolStore = {
  namespaced: true,
  state: () => ({
    showDialog: false,
  }),
  mutations: {
    setShowDialog(state, value = false) {
      state.showDialog = value;
    },
  },
};
